import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { IconProps } from '../types';
import Icon from '../icon';
import useGetColorForProjectThemeComponents from '@/utils/colors/use-get-color-for-project-theme-components';

interface ProjectColorIconProps extends IconProps {
  colorVariable?: EColorVariablesV2;
  contrastAgainstAppBackground?:
    | boolean
    | { colorToChange: EColorVariablesV2; colorToContrastAgainst: EColorVariablesV2 };
  'data-component'?: string;
}

/*
 * ProjectColorIcon is an Icon component that renders with a color
 * from the working project's theme colors, defaulting to the primary color, allowing for automatic contrast
 * adjustment against the app's background color.
 */
const ProjectColorIcon = ({
  name,
  colorVariable,
  contrastAgainstAppBackground,
  color: colorProp,
  'data-component': dataComponent,
  ...rest
}: ProjectColorIconProps) => {
  const { hex } = useGetColorForProjectThemeComponents({
    colorVariable,
    contrastAgainstAppBackground,
  });

  return (
    <Icon
      name={name}
      /*
				Note: passing in color prop will override the calculated project theme color.
				If your intention is just use a prop and not need the project theme,
				then just directly use the Icon component instead of ProjectColorIcon.
			*/
      color={colorProp || hex}
      data-component={dataComponent || 'ProjectColorIcon'}
      {...rest}
    />
  );
};

export default ProjectColorIcon;
